import { Component, OnInit, AfterViewInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

import { GlobalService } from '../../../../services/global.service';

import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent, PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';

import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { catchError, finalize, map, filter, flatMap } from 'rxjs/operators';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { UserModel } from '../../models/chat-models';
import { ChatService } from '../../services/chat.service';

declare var $: any;

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output('selectUser') selectUser = new EventEmitter();

  user_list: any[] = [];

  last_user_key: any;
  search_term: FormControl = new FormControl();
  is_user_paging_end = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public _globalService: GlobalService,
    public _chatService: ChatService
  ) { }

  ngOnInit() {

    this._globalService.addUsersDialog$.subscribe(isTrue => {
      // console.log('isshow', isTrue);
      if (isTrue) {
        setTimeout(() => {
          this.search_term.setValue('');
        }, 0);
        this.loadUsers();
        setTimeout(() => {
          this.is_user_paging_end = false;
        }, 0);
      } else {
        this.user_list = [];
        if (this._globalService.search_users_subscription) {
          this._globalService.search_users_subscription.unsubscribe();
          this.last_user_key = null;
        }
      }
    });

    this.searchUsers();

  }

  ngAfterViewInit() {
    $('#userBoxID').scroll(() => {
      // console.log('scrolllll', $('#userBoxID').scrollTop());
      if ($('#userBoxID').scrollTop() == 0) {
        // console.log('userBoxID');
      }
    });
  }



  onShowDialog() {
    // console.log('onShowDialog');
    this._globalService.addUsersDialog$.next(true);
  }

  onHideDialog() {
    this._globalService.addUsersDialog$.next(false);
  }

  searchUsers() {
    this.search_term.valueChanges
      .debounceTime(300)
      .distinctUntilChanged()
      .subscribe(s_term => {
        // console.log('term ' , term);
        if (s_term) {
          const term = s_term.toLowerCase();
          const users_path = this._globalService.root_path + '/' + this._globalService.domain + '/users/';
          this.user_list = [];
          this._globalService._fireDB.list(users_path, ref =>
            ref.orderByChild('meta/name').startAt(term).endAt(term + '\uf8ff').limitToFirst(10)).valueChanges()
            .first()
            .subscribe((users: any) => {
              // console.log('search users ', term, users_path, users);
              if (users.length) {

                for (let i = 0; i < users.length; i++) {
                  const userdata = {
                    name: users[i].meta.name,
                    email: users[i].meta.email,
                    pictureURLThumbnail: users[i].pictureURLThumbnail,
                    authentication_id: users[i].authentication_id,
                    isAdded: false
                  };

                  // check if it is present in threadlist
                  const uii = this._globalService.individual_thread_list.findIndex(th => th.user_id === users[i].authentication_id);
                  if (uii >= 0) {
                    userdata['isAdded'] = true;
                  }
                  // end

                  if (this._globalService._fireAuth.auth.currentUser.uid !== userdata.authentication_id) {
                    this.user_list.push(userdata);
                  }

                }
                // console.log('search users list', this.user_list);
              }
            });

        } else {
          this.is_user_paging_end = false;
          this.loadUsers();
        }
      });
  }

  loadUsers() {

    this.user_list = [];
    const users_path = this._globalService.root_path + '/' + this._globalService.domain + '/users/';

    if (this._globalService.search_users_subscription) {
      this._globalService.search_users_subscription.unsubscribe();
      this.last_user_key = null;
    }

    this._globalService.search_users_subscription = this._globalService._fireDB.list(users_path, ref =>
      ref.orderByKey().limitToFirst(10))
      .valueChanges()
      .first()
      .subscribe((users: any) => {
        console.log('user ', users);

        if (users.length) {

          for (let i = 0; i < users.length; i++) {
            if (users[i].meta) {
              const userdata = {
                name: users[i].meta.name,
                email: users[i].meta.email,
                pictureURLThumbnail: users[i].meta.pictureURLThumbnail,
                authentication_id: users[i].authentication_id,
                isAdded: false
              };

              // check if it is present in threadlist
              const uii = this._globalService.individual_thread_list.findIndex(th => th.user_id === users[i].authentication_id);
              if (uii >= 0) {
                userdata['isAdded'] = true;
              }
              // end

              if (this._globalService._fireAuth.auth.currentUser.uid !== userdata.authentication_id) {
                this.user_list.push(userdata);
              }
            }
          }
          if (this.user_list.length) {
            this.last_user_key = this.user_list[this.user_list.length - 1].authentication_id;
          }
        }

      });

  }

  loadMoreUsers() {
    this._globalService.global_loader = true;
    const users_path = this._globalService.root_path + '/' + this._globalService.domain + '/users/';

    console.log(this.last_user_key, users_path);
    this._globalService._fireDB.list(users_path, ref =>
      ref.orderByKey().startAt(this.last_user_key).limitToFirst(11)).valueChanges()
      .first()
      .subscribe(
      (users: any) => {
        console.log('more users ', users);
        this._globalService.global_loader = false;
        if (users.length) {

          for (let i = 1; i < users.length; i++) {
            if (users[i].meta) {
              const userdata = {
                name: users[i].meta.name,
                email: users[i].meta.email,
                pictureURLThumbnail: users[i].meta.pictureURLThumbnail,
                authentication_id: users[i].authentication_id,
                isAdded: false
              };

              // check if it is present in threadlist
              const uii = this._globalService.individual_thread_list.findIndex(th => th.user_id === users[i].authentication_id);
              if (uii >= 0) {
                userdata['isAdded'] = true;
              }
              // end

              if (this._globalService._fireAuth.auth.currentUser.uid !== userdata.authentication_id) {
                this.user_list.push(userdata);
              }
            }
          }
          this.last_user_key = this.user_list[this.user_list.length - 1].authentication_id;
          if (users.length < 6) {
            this.is_user_paging_end = true;
          }
          // console.log('users list', this.user_list);
        }
      },
      err => {
        this._globalService.global_loader = false;
      });
  }


  createNewThread(user) {

    if (!this.checkUserInThreadList(user)) {
      this._globalService.global_loader = true;

      const data = {
        details: {
          creation_date: firebase.database.ServerValue.TIMESTAMP,
          creator_entity_id: this._globalService._fireAuth.auth.currentUser.uid,
          last_message_added: firebase.database.ServerValue.TIMESTAMP,
          type: 0,   // for one to one chat
          group_name: '',
          group_picture: '',
          group_picture_thumbnail: ''
        },
        users: {
          [this._globalService._fireAuth.auth.currentUser.uid]: true,
          [user.authentication_id]: true
        }
      };
      const threadToSave = Object.assign({}, data);
      const newThreadKey = this._globalService._fireDB.database.ref(this._globalService.root_path + '/'
        + this._globalService.domain + '/threads/').push().key;

      const datasave = {};
      datasave[this._globalService.root_path + '/'
        + this._globalService.domain + '/threads/' + newThreadKey] = threadToSave;

      datasave[this._globalService.root_path + '/' + this._globalService.domain +
        '/users/' + this._globalService._fireAuth.auth.currentUser.uid + '/threads/' + newThreadKey] = { unseenCount: 0 };

      datasave[this._globalService.root_path + '/' + this._globalService.domain +
        '/users/' + user.authentication_id + '/threads/' + newThreadKey] = { unseenCount: 0 };

      // console.log('datasave', datasave);

      this._globalService.firebaseUpdate(datasave)
        .then((res) => {
          // console.log(`res ${res}`);

          // check if it is present in threadlist
          const uii = this.user_list.findIndex(th => th.authentication_id === user.authentication_id);
          // console.log(uii, user);
          if (uii >= 0) {
            this.user_list[uii].isAdded = true;
          }
          // end

          // this._globalService.openSnackBar('Added successfuly', 'Dismiss');
          setTimeout(() => {
            this._globalService.global_loader = false;
            this.startChat(user);
          }, 500) ;

        })
        .catch((err) => {
          //  console.log(`error ${err}`);
          this._globalService.global_loader = false;
          this._globalService.openSnackBar(err, 'Dismiss');
        });

    } else {
      this.startChat(user);
    }

  }

  startChat(user) {
    if (user && this.checkUserInThreadList(user)) {
      this.selectUser.emit(user);
    }
    if (!this.checkUserInThreadList(user)) {
      this.createNewThread(user);
    }
  }

  checkUserInThreadList(user) {
    const fi = this._globalService.individual_thread_list.findIndex(th => th.user_id === user.authentication_id);
    if (fi >= 0) {
      return true;
    } else {
      return false;
    }
  }


  ngOnDestroy() {

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/chat/sub-components/add-user/add-user.component.ts